import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative bg-amff-teal text-white" }
const _hoisted_2 = { class: "\n        md:max-w-lg\n        lg:max-w-xl\n        xl:max-w-2xl\n        2xl:max-w-4xl\n        mx-auto\n        py-16\n        px-container\n      " }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "\n          font-display\n          uppercase\n          text-center text-xl\n          sm:text-2xl\n          md:text-3xl\n          lg:text-2xl\n          mt-2\n        " }, [
  /*#__PURE__*/_createTextVNode(" Una semana en Mallorca. "),
  /*#__PURE__*/_createVNode("br", { class: "lg:hidden" }),
  /*#__PURE__*/_createTextVNode("Un mes en Filmin ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BonoHeroLettering = _resolveComponent("BonoHeroLettering")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_BonoHeroLettering, { class: "w-full h-auto" }),
      _hoisted_3
    ]),
    _createVNode("div", {
      class: "\n        absolute\n        hidden\n        md:block\n        inset-y-0\n        left-0\n        h-full\n        w-1/4\n        aspect-square\n      ",
      style: {
        backgroundImage: `url(${_ctx.baseURL}img/bono/header-camiseta-tarjeta.png?date=2022-07-06)`,
        backgroundPosition: 'center left',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      }
    }, null, 4),
    _createVNode("div", {
      class: "\n        absolute\n        hidden\n        md:block\n        inset-y-0\n        right-0\n        h-full\n        w-1/4\n        aspect-square\n      ",
      style: {
        backgroundImage: `url(${_ctx.baseURL}img/bono/header-totebag.png?date=2022-07-06)`,
        backgroundPosition: 'center right',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      }
    }, null, 4),
    _createVNode("img", {
      class: "block md:hidden w-full h-auto",
      src: `${_ctx.baseURL}img/bono/group.png?date=2022-07-06`,
      srcset: 
        [
          `${_ctx.baseURL}img/bono/group.png?date=2022-07-06 1x`,
          `${_ctx.baseURL}img/bono/group@2x.png?date=2022-07-06 2x`,
          `${_ctx.baseURL}img/bono/group@3x.png?date=2022-07-06 3x`,
        ].join(' ')
      
    }, null, 8, ["src", "srcset"])
  ]))
}